import React from 'react'
import { PageLayout } from '../components/common/PageLayout'
import { Section, FeatureCard } from '../components/common/DesignComponents'

export function FeaturesPage(): React.ReactElement {
  return (
    <PageLayout title="Features" subtitle="Discover what makes BabyKingdom magical">
      <Section title="Core Features">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          <FeatureCard
            emoji="👶"
            title="Child Profiles"
            description="Create and manage multiple child profiles with unique personalities and development stages."
            colorFrom="from-pink-100"
            colorTo="to-pink-50"
            borderColor="border-pink-200"
          />
          <FeatureCard
            emoji="🎮"
            title="Interactive Games"
            description="Engage children with educational games that teach and entertain simultaneously."
            colorFrom="from-purple-100"
            colorTo="to-purple-50"
            borderColor="border-purple-200"
          />
          <FeatureCard
            emoji="🏆"
            title="Achievement System"
            description="Unlock achievements and badges as your child reaches milestones and learns new skills."
            colorFrom="from-yellow-100"
            colorTo="to-yellow-50"
            borderColor="border-yellow-200"
          />
          <FeatureCard
            emoji="💰"
            title="Virtual Currency"
            description="Earn coins through gameplay and spend them on items and upgrades in the shop."
            colorFrom="from-blue-100"
            colorTo="to-blue-50"
            borderColor="border-blue-200"
          />
          <FeatureCard
            emoji="🛍️"
            title="Virtual Shop"
            description="Purchase special items, cosmetics, and power-ups to customize your child's experience."
            colorFrom="from-green-100"
            colorTo="to-green-50"
            borderColor="border-green-200"
          />
          <FeatureCard
            emoji="📊"
            title="Progress Tracking"
            description="Monitor your child's growth, learning progress, and developmental milestones."
            colorFrom="from-indigo-100"
            colorTo="to-indigo-50"
            borderColor="border-indigo-200"
          />
        </div>
      </Section>

      <Section title="Why Parents Love BabyKingdom">
        <div className="bg-gradient-to-br from-purple-50 to-pink-50 p-12 rounded-3xl border-4 border-purple-200">
          <ul className="space-y-4">
            <li className="flex items-start gap-4">
              <span className="text-3xl">✨</span>
              <div>
                <h4 className="font-black text-lg text-purple-700 mb-1">Safe & Secure</h4>
                <p className="text-gray-700">All content is curated and age-appropriate for children.</p>
              </div>
            </li>
            <li className="flex items-start gap-4">
              <span className="text-3xl">🎓</span>
              <div>
                <h4 className="font-black text-lg text-purple-700 mb-1">Educational</h4>
                <p className="text-gray-700">Games designed by child development experts to enhance learning.</p>
              </div>
            </li>
            <li className="flex items-start gap-4">
              <span className="text-3xl">⏱️</span>
              <div>
                <h4 className="font-black text-lg text-purple-700 mb-1">Healthy Playtime</h4>
                <p className="text-gray-700">Built-in parental controls and time management features.</p>
              </div>
            </li>
            <li className="flex items-start gap-4">
              <span className="text-3xl">👨‍👩‍👧</span>
              <div>
                <h4 className="font-black text-lg text-purple-700 mb-1">Family Bonding</h4>
                <p className="text-gray-700">Play together and celebrate your child's achievements.</p>
              </div>
            </li>
          </ul>
        </div>
      </Section>
    </PageLayout>
  )
}
